import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isSpinning: false
  },
  mutations: {
    CHANGE_SPIN_STATE (state, value) {
      state.isSpinning = value
    }
  },
  actions: {
  },
  modules: {
  }
})
